var map = {
	"./amica": "27a1",
	"./amica.json": "27a1",
	"./astanet": "937c",
	"./astanet.json": "937c",
	"./baltycka": "8763",
	"./baltycka.json": "8763",
	"./bialy-kamien": "ab73",
	"./bialy-kamien.json": "ab73",
	"./centrum-riviera": "e4d1",
	"./centrum-riviera.json": "e4d1",
	"./cpr-demo": "7f47",
	"./cpr-demo.json": "7f47",
	"./demo-knowledge": "b3eb",
	"./demo-knowledge.json": "b3eb",
	"./develop": "e757",
	"./develop.json": "e757",
	"./goodfood": "3c34",
	"./goodfood.json": "3c34",
	"./lira": "bfdc",
	"./lira.json": "bfdc",
	"./pasaz-grunwaldzki": "fa41",
	"./pasaz-grunwaldzki.json": "fa41",
	"./pomorska": "3be4",
	"./pomorska.json": "3be4",
	"./posnania": "bd5f",
	"./posnania.json": "bd5f",
	"./valo-motion": "64ac",
	"./valo-motion.json": "64ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0b5";